import { Pipe, PipeTransform } from '@angular/core';

import { ProgrammingUtilsService } from '../../../common/services/utils.service';
import { ScheduleQuickstartContext } from './../services/schedule.service';

@Pipe({
  name: 'timeLabel'
})
export class TimeLabelPipe implements PipeTransform {

  constructor(
    private utils: ProgrammingUtilsService
  ) { }


  transform(vm: ScheduleQuickstartContext, args?: any): any {
    // console.log('preparing time label with', vm);
    let display = '';
    if (vm) {
      if (vm.isFixedTime) {
        // at a fixed time
        display += ' at ';
        let now = new Date();
        // console.log('time-label: current offset minutes are:', vm.start.offset_minutes);

        let parts = vm.startTime.split(':');
        let minutes = (parseInt(parts[0]) * 60) + parseInt(parts[1]);
        display += this.utils.toTimeDisplay(now.getFullYear(), now.getMonth()+1, now.getDate(), minutes);
        display += ' ';
      } else {
        // relative to sunrise sunset
        if (vm.sunriseSunsetOffsetType === 0) {
          display += ' at ';
        } else {
          display += ' ' + vm.sunriseSunsetOffsetInterval + ' minutes ';
          if (vm.sunriseSunsetOffsetType === 1) {
            display += 'before ';
          } else if (vm.sunriseSunsetOffsetType === 2) {
            display += 'after ';
          }
        }

        switch (vm.sunriseOrSunset) {
          case 1: display += 'sunrise '; break;
          case 2: display += 'sunset '; break;
        }
      }

      if (vm.isRandomized) {
        display += ('+/- ' + vm.randomizeBy + ' minutes ');
      }
    }

    return display;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/pipes/time-label.pipe.ts